import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { graphContainer } from './graphContainers';
import { actions } from '../../SuperUser/Report/redux/actions';
import { ColorPalette } from '../DashboardColorPalettes';
import Strings from '../../../Strings';
import GenericCategoryGraph from '../../../components/Graphs/GenericCategoryGraph';

const ageRanges = ['0-9', '10-19', '20-29', '30-39', '40-49', '50-59', '60-69', '70-79', '80-89', '90-99', '100+'];

function PatientsAgeGender(props) {
  const [data, setData] = useState();
  const { colorPalette, graphType, orgIds, refreshTimestamp, getPatientsStatistics } = props;

  React.useEffect(() => {
    // Use cached dispatch to avoid duplicate API calls
    import('../../../utils/apiCache').then(({ cachedDispatch }) => {
      cachedDispatch(
        'patients_statistics',
        { orgId: orgIds && orgIds.length > 0 ? orgIds : undefined },
        () => getPatientsStatistics({ orgId: orgIds && orgIds.length > 0 ? orgIds : undefined }),
        60000, // Cache for 1 minute
      ).then(response => {
        setData(response?.response?.patients_by_age_and_gender);
      });
    });
  }, [refreshTimestamp, orgIds]);

  const dataSeries = Object.values(Strings.genders).map((g, i) => ({
    name: g,
    color: colorPalette?.interpolate((i + 1) / (Object.values(Strings.genders).length + 1)),
    selector: item => item[g],
  }));

  return graphContainer(
    <GenericCategoryGraph
      graphData={
        data
          ? ageRanges.map(range => ({
              age: range,
              Female: data?.Female?.[range] || 0,
              Male: data?.Male?.[range] || 0,
              Other: data?.Other?.[range] || 0,
            }))
          : []
      }
      hasBorder
      forceCondensed
      xAxisTopPosition={false}
      yAxisWidth={40}
      yAxisUnit=""
      tooltipTitle="Patients age and gender"
      dataSeries={dataSeries}
      categorySelector={item => item.age}
      hasReferenceAreas
      hasLegend
      graphType={graphType}
    />,
    'Patients Age and Gender',
  );
}

PatientsAgeGender.widgetId = 'PatientsAgeGenderWidget';

PatientsAgeGender.propTypes = {
  getPatientsStatistics: PropTypes.func.isRequired,
  colorPalette: PropTypes.object,
  graphType: PropTypes.string,
  refreshTimestamp: PropTypes.number,
  orgIds: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = state => {
  return {
    colorPalette:
      ColorPalette[state.dashboardState.configuration?.allDashboards?.colorPalette] || Object.values(ColorPalette)[0],
    orgIds: state.entities?.orgFilter?.orgIds,
  };
};

const mapDispatchToProps = dispatch => ({
  getPatientsStatistics: pageRequest => dispatch(actions.getPatientsStatistics(pageRequest)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PatientsAgeGender);
